import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../supabaseClient';
import CardReflexao from './CardReflexao';

const PAGE_SIZE = 3;

const IconFeather = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--lavender)', opacity: 0.5 }}>
    <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
    <line x1="16" y1="8" x2="2" y2="22" />
    <line x1="17.5" y1="15" x2="9" y2="15" />
  </svg>
);

function seteDiasAtras() {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d.toISOString();
}

export default function FeedReflexoes({ userId }) {
  const [reflexoes, setReflexoes] = useState([]);
  const [meIdentificadoIds, setMeIdentificadoIds] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const [temMais, setTemMais] = useState(false);
  const [carregandoMais, setCarregandoMais] = useState(false);

  const buscarMinhasIdentificacoes = useCallback(async (ids) => {
    if (!userId || !ids.length) return;
    const { data } = await supabase
      .from('me_identifico')
      .select('reflexao_id')
      .eq('user_id', userId)
      .in('reflexao_id', ids);
    if (data) {
      setMeIdentificadoIds(prev => {
        const next = new Set(prev);
        data.forEach(r => next.add(r.reflexao_id));
        return next;
      });
    }
  }, [userId]);

  const buscarReflexoes = useCallback(async (novoOffset = 0) => {
    const { data } = await supabase
      .from('reflexoes_anonimas')
      .select('*')
      .gte('created_at', seteDiasAtras())
      .order('created_at', { ascending: false })
      .range(novoOffset, novoOffset + PAGE_SIZE - 1);

    if (data) {
      setTemMais(data.length === PAGE_SIZE);
      if (novoOffset === 0) {
        setReflexoes(data);
        await buscarMinhasIdentificacoes(data.map(r => r.id));
      } else {
        setReflexoes(prev => [...prev, ...data]);
        await buscarMinhasIdentificacoes(data.map(r => r.id));
      }
    }
  }, [buscarMinhasIdentificacoes]);

  useEffect(() => {
    buscarReflexoes(0).finally(() => setLoading(false));
  }, [buscarReflexoes]);

  const carregarMais = async () => {
    setCarregandoMais(true);
    const novoOffset = offset + PAGE_SIZE;
    await buscarReflexoes(novoOffset);
    setOffset(novoOffset);
    setCarregandoMais(false);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!reflexoes.length) {
    return (
      <div className="feed-empty-state">
        <IconFeather />
        <p className="feed-empty-titulo">Ainda não há reflexões compartilhadas</p>
        <p className="feed-empty-sub">Seja a primeira a inspirar a comunidade com seu compartilhamento.</p>
      </div>
    );
  }

  return (
    <div className="feed-reflexoes">
      {reflexoes.map(r => (
        <CardReflexao
          key={r.id}
          reflexao={r}
          userId={userId}
          jaMeIdentifiquei={meIdentificadoIds.has(r.id)}
          onIdentificou={id => setMeIdentificadoIds(prev => new Set([...prev, id]))}
        />
      ))}

      {temMais && (
        <button
          className="btn btn-ghost feed-carregar-mais"
          onClick={carregarMais}
          disabled={carregandoMais}
        >
          {carregandoMais ? 'Carregando...' : 'Carregar mais reflexões'}
        </button>
      )}
    </div>
  );
}
